import React, { ErrorInfo, PropsWithChildren } from 'react'
import * as Sentry from '@sentry/react'

type ErrorBoundaryProps = PropsWithChildren<{
    // eslint-disable-next-line react/require-default-props
    fallbackComponent?: React.ReactNode
}>

type ErrorBoundaryState = {
    hasError: boolean
}

/**
 * @description generic error boundary component
 */
class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props)
        this.state = {
            hasError: false,
        }
    }

    static getDerivedStateFromError() {
        return {
            hasError: true,
        }
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        Sentry.withScope((scope) => {
            scope.setLevel('error')
            scope.setExtras({ info })
            Sentry.captureException(error)
        })
    }

    render() {
        const { hasError } = this.state
        const { fallbackComponent, children } = this.props
        if (hasError) {
            return fallbackComponent
        }

        return children
    }
}

export default ErrorBoundary
